import classNames from 'classnames/bind';
import styles from '../Dashboard.module.scss';

import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Legend, PolarAngleAxis, RadialBar, RadialBarChart, ResponsiveContainer } from 'recharts';
import { useResponsiveValue } from '~/hooks/useResponsiveValue';
import { IInstallationLocation } from '~/utils/interface/dashboard';

const cx = classNames.bind(styles);

const renderLegend = (fontSize: string, deployLabel: string, nonDeployedLabel: string) => (
  <ul className='flex justify-center'>
    <li style={{ marginBottom: 4, marginRight: 16 }}>
      <span style={{ color: '#CCCCCC', marginRight: 6, fontSize }}>●</span>
      {nonDeployedLabel}
    </li>
    <li style={{ marginBottom: 4 }}>
      <span style={{ color: '#3D9149', marginRight: 6, fontSize }}>●</span>
      {deployLabel}
    </li>
  </ul>
);

const FacilitySummary = (props: { installation_location?: IInstallationLocation }) => {
  const { t } = useTranslation('admin/home');
  const { installation_location } = props;

  const responsiveFontSize = useResponsiveValue({
    lg: '12px',
    xs: '10px',
    xl: '14px',
  });

  const radiusWidth = useResponsiveValue({
    lg: {
      innerRadius: '100%',
      outerRadius: '160%',
    },
    xl: {
      innerRadius: '160%',
      outerRadius: '100%',
    },
  });
  return (
    <Box className='h-[48%]'>
      <Typography className={cx('dashboard-widget-title', 'dashboard-widget-title-text')}>
        {t('facilityCount')}
      </Typography>
      <Box className={cx('border border-[#DFDFDF] rounded-b-[20px] w-full', 'dashboard-widget-body')}>
        <ResponsiveContainer width='100%' height='100%'>
          <RadialBarChart
            cx='50%'
            cy='70%'
            innerRadius={radiusWidth?.innerRadius ?? '120%'}
            outerRadius={radiusWidth?.outerRadius ?? '250%'}
            data={[
              {
                name: t('facilityComponent.deployed'),
                value: ((installation_location?.deployed ?? 0) / (installation_location?.total ?? 1)) * 100,
                fill: '#3D9149',
              },
            ]}
            startAngle={180}
            endAngle={0}
          >
            <PolarAngleAxis type='number' domain={[0, 100]} angleAxisId={0} tick={false} />
            <RadialBar background dataKey='value' cornerRadius={10} />
            <text
              x='50%'
              y='60%'
              textAnchor='middle'
              dominantBaseline='middle'
              fill='#3D9149'
              fontSize={22}
              fontWeight='bold'
            >
              {installation_location?.deployed ?? 0}
            </text>
            <Legend
              verticalAlign='bottom'
              content={renderLegend(
                responsiveFontSize ?? '10px',
                t('facilityComponent.deployed'),
                t('facilityComponent.nonDeployed')
              )}
            />
          </RadialBarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default memo(FacilitySummary);
